class FooterElement extends HTMLElement {
  constructor() {
    super();

    // Select all collapse buttons within the footer
    const collapseButtons = this.querySelectorAll('[collapse-btn]');

    collapseButtons?.forEach((button) => {
      button?.addEventListener('click', () => {
        const content = button.parentElement.querySelector('[collapse-content]');
        if (!content) return;

        const isExpanded = content.classList.contains('active');

        if (isExpanded) {
          // Collapse the content
          content.style.setProperty('--max-height', '0px');
          content.classList.remove('active');
          button.classList.remove('active');
          button.setAttribute('aria-expanded', 'false');
        } else {
          // Expand the content
          const scrollHeight = content.scrollHeight;
          content.style.setProperty('--max-height', `${scrollHeight}px`);
          content.classList.add('active');
          button.classList.add('active');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
}

customElements.define('footer-ele', FooterElement);